export default "__VITE_ASSET__SXtsBHg5__"